import { createServerColumnHelper } from '../../shared-compat/DataTable/hooks';
import type { Sample } from '../Service.types';

const helper = createServerColumnHelper<Sample>();
const ch = helper.accessor;
// const display = helper.display;

export const unReceivedSampleColumns = () => [
  ch('activityCrmId', 'string', {
    header: 'Activity ID',
    enableColumnFilter: true,
    cell: (info) => (info.getValue() == null ? 'N/A' : info.getValue()),
    footer: (props) => props.column.id
  }),
  ch('barcodeId', 'string', {
    header: 'Barcode',
    enableColumnFilter: false,
    cell: (info) => info.getValue(),
    footer: (props) => props.column.id
  }),
  ch('processingStatus', 'string', {
    header: 'Result Status',
    enableColumnFilter: true,
    cell: (info) => info.getValue(),
    footer: (props) => props.column.id
  }),
  ch('siteName', 'string', {
    header: 'Customer',
    enableColumnFilter: true,
    cell: (info) => info.getValue(),
    footer: (props) => props.column.id
  }),
  ch('assetName', 'string', {
    header: 'Asset',
    enableColumnFilter: true,
    cell: (info) => info.getValue(),
    footer: (props) => props.column.id
  }),
  ch('scannedAt', 'date', {
    header: 'Scanned At',
    enableColumnFilter: true,
    cell: (info) => info.row.original.scannedAt?.toLocaleDateString(),
    footer: (props) => props.column.id
  })

  // ch('reviewed', 'boolean', {
  //   header: 'Reviewed',
  //   enableColumnFilter: true,
  //   cell: (info) => (info.getValue() ? 'Yes' : 'No'),
  //   footer: (props) => props.column.id
  // }),
  // ch('reviewDescription', 'string', {
  //   header: 'Review Description',
  //   enableColumnFilter: true,
  //   cell: (info) => info.getValue(),
  //   footer: (props) => props.column.id
  // }),
  // ch('reviewOutcome', 'string', {
  //   header: 'Review Outcome',
  //   enableColumnFilter: true,
  //   cell: (info) => info.getValue(),
  //   footer: (props) => props.column.id
  // }),
];
